import React from 'react';

const shimmer = `
  @keyframes shimmer {
    0% { background-position: -1000px 0; }
    100% { background-position: 1000px 0; }
  }
`;

const SkeletonBox = ({ width = "100%", height = "16px", borderRadius = "6px", style = {} }) => (
  <div style={{
    width,
    height,
    borderRadius,
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "1000px 100%",
    animation: "shimmer 1.5s infinite linear",
    ...style
  }} />
);

const OrderCardSkeleton = () => (
  <div className="border border-gray-100 border-l-4 border-l-gray-200 rounded-2xl p-5 md:p-6 mb-3 flex items-center gap-4 bg-white">
    {/* Image */}
    <SkeletonBox width="52px" height="52px" borderRadius="10px" style={{ flexShrink: 0 }} />
    
    <div className="flex-1">
      {/* Top row: ID + badge + phone + city + agent */}
      <div className="flex flex-wrap gap-2.5 items-center mb-2.5">
        <SkeletonBox width="60px" height="18px" />
        <SkeletonBox width="80px" height="22px" borderRadius="20px" />
        <SkeletonBox width="110px" height="14px" />
        <SkeletonBox width="70px" height="14px" />
        <SkeletonBox width="120px" height="14px" />
      </div>
      {/* Bottom row: product name + date */}
      <div className="flex flex-wrap gap-4 items-center">
        <SkeletonBox width="220px" height="14px" />
        <SkeletonBox width="140px" height="14px" />
      </div>
    </div>

    {/* Right: price + button */}
    <div className="flex flex-col items-end gap-2.5 flex-shrink-0">
      <SkeletonBox width="80px" height="20px" />
      <SkeletonBox width="160px" height="38px" borderRadius="8px" />
    </div>
  </div>
);

export const OrdersSkeletonList = ({ count = 8 }) => (
  <>
    <style>{shimmer}</style>
    {Array.from({ length: count }).map((_, i) => (
      <OrderCardSkeleton key={i} />
    ))}
  </>
);
